<!--作业-->
<template>
    <div class="el-SchoolAssignment">
        <!-- <h1 class="head_title" style="margin-top:-20px;">
            Python课程设计 平时作业
        </h1> -->
        <el-row class="page_content">
            <h1 class="head_title_white">
                <h1 style="float: left;color: #000000;line-height: 40px;margin: 0;">{{courseName}}   作业</h1>
                <el-button type="warning" @click="wrongQuestion">错题本</el-button>
                <el-button type="primary" @click="closePage">关 闭</el-button>
            </h1>
            <div class="bg_"></div>
            <el-row style="padding: 20px;">
                <el-row class="zy" v-for='(item,index) in homeworkList' :key="index">
                    <div class="zyleft">作业{{$chineseNum(index)}}</div>
                    <div class="zyleft">剩余次数：{{item.remainHomeworkCount}}次</div>
                    <!-- <h1 class="limit_line_one" :title="item.paperName">
                        {{item.paperName}}
                    </h1> -->
                    <!-- <p>剩余次数：{{item.remainHomeworkCount}}次</p> -->
                    <div style="text-align: right;line-height:150px">
                        <el-button type="primary" v-show="item.remainHomeworkCount > 0" @click="ksks(item,index)" style="border-color:rgba(0, 191, 191, 1);background-color:rgba(0, 191, 191, 1)">{{item.homeworkStudentStateText}}</el-button>
                        <el-button type="success" @click="zyjl(item,index)" style="border-color:rgba(128, 128, 255, 1);background-color:rgba(128, 128, 255, 1)">作业记录</el-button>
                    </div>
                </el-row>
            </el-row>

        </el-row>
    </div>
</template>
<script>
import {getStorageKeyForRoleTag, openWithRoleTag} from "../../common/ulit";

export default {
  name: "SchoolAssignment",
  data() {
    return {
      courseName:this.$Base64.decode(this.$route.query.courseName),
      dialogImageUrl: '',
      dialogVisible: false,
      tePlanCourseId:this.$route.query.tePlanCourseId,
      homeworkList:[] //作业列表
    };
  },
  created() {
    if(this.$isEmpty(this.tePlanCourseId)){
      this.$message({
         message: "课程数据丢失，请返回上一页！",
         type: 'warning'
      });
    }else{
      this.getHomeworkList();
      localStorage.removeItem(getStorageKeyForRoleTag('homeworkName_tag'));
      let this_ = this;
      setInterval(function() {
        if(localStorage.getItem(getStorageKeyForRoleTag('homeworkName_tag')) == 1){
          localStorage.removeItem(getStorageKeyForRoleTag('homeworkName_tag'));
          this_.getHomeworkList();
        }
      }, 1000);
    }
  },
  methods: {
    closePage(){
      window.location.href="about:blank";
      window.close();
    },
    wrongQuestion(){
      this.$router.push({name:'WrongQuestion',query:{tePlanCourseId:this.tePlanCourseId}});
    },
    ksks(item,index){
      localStorage.setItem(getStorageKeyForRoleTag('homeworkName_examination'),this.courseName);
      // this.$router.push({name:'Examination',query:{homeworkId:item.homeworkId}});
        openWithRoleTag(window.location.origin + '/Examination?homeworkId='+item.homeworkId+"&courseName="+this.$Base64.encode(this.courseName));
    },
    zyjl(item,index){
      localStorage.setItem(getStorageKeyForRoleTag('homeworkName_examination'),this.courseName);
      this.$router.push({name:'JobRecord',query:{homeworkId:item.homeworkId,courseName:this.courseName}});
    },getHomeworkList(){ //获取作业列表
      this.$store.dispatch("user/getHomeworkList",{tePlanCourseId:this.tePlanCourseId}).then((ret) => {
        if (ret.code === 0 || ret.code === '0') {
          // this.courseName = ret.courseName +"    平时作业";
          this.homeworkList = ret.data;
        } else {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }
      });
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-SchoolAssignment{
    .head_title_white{
        text-align: right;
        margin-bottom:0;
        padding: 10px 30px;
    }
    .bg_{
        height: 10px;
        background-color: @mainBg;
        margin: 0 -20px;
    }
    .learning_img{
        width: 280px;height: 220px;border: 1px solid rgb(238, 238, 238);float: left;margin-right: 20px;
    }
    .el-main{
        min-width: 1200px;
    }
    .zyleft{
        float: left;
        line-height: 150px;
        padding: 0 40px 0 25px;
        font-size: 20px;
        color: @primary;
    }
    .zy{
        border: 1px solid rgb(164, 164, 255);width: 650px;min-height: 150px;border-radius: 10px;margin: 25px auto;padding: 0 20px;
    }
    .odyContainer{
        height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/SchoolAssignment.vue